import { PropsWithChildren, useEffect } from 'react'
import { Listeners, startSSE } from 'src/api/sse'
import { dreamFrozen } from 'src/api/sse/listeners/dreamFrozen'
import { userNotifications } from 'src/api/sse/listeners/user-notifications'
import { personalDreamStatusListeners } from 'src/api/sse/listeners/personal-dream-status'
import { withdrawalListeners } from 'src/api/sse/listeners/wallet-transaction'
import { lobbySSEsignal } from 'src/api/sse/signals/lobbySSEsignal'
import { liveActivityListeners } from '@/features/dreams/live-activities'

export const SseProvider = ({ children }: PropsWithChildren) => {
  useEffect(() => {
    const lobbySSE = startSSE()
    lobbySSEsignal.value = lobbySSE

    const { addListener, close } = lobbySSE

    addListener('dream.frozen', dreamFrozen)

    Object.entries(liveActivityListeners).forEach(([event, cb]) => {
      addListener(event as keyof Listeners, cb, 'lobby')
    })

    Object.entries(userNotifications).forEach(([event, cb]) => {
      addListener(event as keyof Listeners, cb, 'personal')
    })

    // Personal события для обновления статуса моего dream на главной
    Object.entries(personalDreamStatusListeners).forEach(([event, cb]) => {
      addListener(event as keyof Listeners, cb, 'personal')
    })

    // Personal события для обновления баланса и истории транзакций кошелька
    Object.entries(withdrawalListeners).forEach(([event, cb]) => {
      addListener(event as keyof Listeners, cb, 'personal')
    })

    return () => {
      lobbySSEsignal.value = null
      close()
    }
  }, [])

  return <>{children}</>
}
